import { IValidationRule } from "@/types"

const documentCategoryValidationRules: { [s: string]: IValidationRule } = {
    documentCategoryName: {
        required: true,
    },
    usageScope: {
        required: true,
    },
}

export default documentCategoryValidationRules
